// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client'; // <-- actualizado
import { HelmetProvider } from 'react-helmet-async';
import './styles/index.css';
import App from './App';
import { initErrorReporter } from './utils/errorReporter';

initErrorReporter();

// Definición simple de reportWebVitals para evitar errores
const reportWebVitals = () => {
  // Función vacía
  console.log('Web vitals reporting disabled');
};

const root = ReactDOM.createRoot(document.getElementById('root')); // <-- actualizado
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();